import { FilterOption } from '../../../components/ui';

// Функции для получения переводов с контекстом
export const getOrderStatuses = (t: (key: string) => string): FilterOption[] => [
  { key: 'all', label: t('partner.orders.filters.status.label') },
  { key: 'in_progress', label: t('partner.orders.filters.status.accepted') },
  { key: 'waiting', label: t('partner.orders.filters.status.waiting') },
  { key: 'canceled', label: t('partner.orders.filters.status.canceled') },
  { key: 'completed', label: t('partner.orders.filters.status.completed') },
  { key: 'not_started', label: t('partner.orders.filters.status.not_started') },
];

export const getTableColumns = (t: (key: string) => string) => [
  { name: t('partner.orders.table.columns.id'), key: 'id' },
  { name: t('partner.orders.table.columns.model'), key: 'model' },
  { name: t('partner.orders.table.columns.offer'), key: 'offer', tooltip: t('partner.orders.table.columns.offerTooltip') },
  { name: t('partner.orders.table.columns.status'), key: 'status' },
  { name: t('partner.orders.table.columns.createdAt'), key: 'createdAt' },
];

export const getStatusLabels = (t: (key: string) => string) => ({
  in_progress: t('partner.orders.status.accepted'),
  waiting: t('partner.orders.status.waiting'),
  canceled: t('partner.orders.status.canceled'),
  completed: t('partner.orders.status.completed'),
  not_started: t('partner.orders.status.not_started'),
});

// Статические константы
export const ORDER_STATUSES: FilterOption[] = [
  { key: 'all', label: 'Статус' },
  { key: 'in_progress', label: 'Принят' },
  { key: 'waiting', label: 'В ожидании' },
  { key: 'canceled', label: 'Отклонен' },
  { key: 'completed', label: 'Завершен' },
];

export const TABLE_COLUMNS = [
  { name: 'ID', key: 'id' },
  { name: 'Модель', key: 'model' },
  { name: 'Оффер', key: 'offer' },
  { name: 'Подписчики', key: 'subscribers' },
  { name: 'Статистика', key: 'statistics' },
  { name: 'Статус', key: 'status' },
  { name: 'Дата создания', key: 'createdAt' },
];

export const STATUS_LABELS = {
  in_progress: 'Принят',
  waiting: 'В ожидании',
  canceled: 'Отклонен',
  completed: 'Завершен',
} as const;

export const DEFAULT_FILTERS = {
  search: '',
  status: 'all',
  offer: 'all',
};

export const DEFAULT_PAGE_SIZE = 10;
export const OFFERS_PAGE_SIZE = 30;
export const SEARCH_DEBOUNCE_DELAY = 500;
